import { useApiQuery, useApiMutation } from '../../../api/client';

export interface Notification {
  id: string;
  userId: string;
  type: string;
  priority: 'ACTION' | 'ALERT' | 'SYSTEM';
  title: string;
  body?: string;
  metadata?: Record<string, any>;
  actionType?: string;
  actionPayload?: Record<string, any>;
  isRead: boolean;
  resolvedAt?: string;
  createdAt: string;
}

export function useNotifications(options?: { priority?: string; resolved?: boolean }) {
  const params = new URLSearchParams();
  if (options?.priority) params.set('priority', options.priority);
  if (options?.resolved !== undefined) params.set('resolved', String(options.resolved));
  const qs = params.toString();
  const endpoint = `/api/notifications${qs ? `?${qs}` : ''}`;

  return useApiQuery<Notification[]>(
    ['notifications', options?.priority, options?.resolved],
    endpoint,
    { staleTime: 30_000 },
  );
}

export function useMarkNotificationRead() {
  return useApiMutation<void, { id: string }>(
    (data) => `/api/notifications/${data.id}/read`,
    'PATCH',
    { invalidateKeys: [['notifications']] },
  );
}

export function useMarkAllRead() {
  return useApiMutation<void, void>(
    '/api/notifications/read-all',
    'POST',
    { invalidateKeys: [['notifications']] },
  );
}

export function useResolveAllNotifications() {
  return useApiMutation<void, void>(
    '/api/notifications/resolve-all',
    'POST',
    { invalidateKeys: [['notifications']] },
  );
}

export function useResolveNotification() {
  return useApiMutation<void, { id: string }>(
    (data) => `/api/notifications/${data.id}/resolve`,
    'PATCH',
    { invalidateKeys: [['notifications']] },
  );
}

export function useDismissNotification() {
  return useApiMutation<void, { id: string }>(
    (data) => `/api/notifications/${data.id}`,
    'DELETE',
    { invalidateKeys: [['notifications']] },
  );
}
